import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import "../style/Header.css";
import Logo from "../assets/images/Logo.JPG";
import { Menu } from "lucide-react";
import { motion } from "framer-motion";

const Header = () => {
  const [isDrawerOpen, setDrawerOpen] = useState(false);
  const navigate = useNavigate();

  const toggleDrawer = () => {
    setDrawerOpen(!isDrawerOpen);
  };

  return (
    <header className="header">
      {/* Logo */}
      <div className="logo-container" onClick={() => navigate("/home")}>
        <img src={Logo} alt="Logo" height="30px" width="60px" />
        <div className="logo-tagline">Steel Infinity World</div>
      </div>

      {/* Navigation for larger screens */}
      <nav className="nav-menu">
        <Link to="/home" className="nav-menu-link">
          Home
        </Link>
        <Link to="/aboutus" className="nav-menu-link">
          About Us
        </Link>
        <Link to="/sampledrawings" className="nav-menu-link">
          Sample Drawings
        </Link>
        <Link to="/contactus" className="nav-menu-link contact-us-button">
          Contact Us
        </Link>
      </nav>

      {/* Hamburger menu for smaller screens */}
      <button className="menu-toggle" onClick={toggleDrawer}>
        <Menu size={28} />
      </button>

      {/* Drawer for smaller screens */}
      {isDrawerOpen && (
        <>
          <motion.div
            initial={{ x: "100%" }}
            animate={{ x: 0 }}
            exit={{ x: "100%" }}
            transition={{ duration: 0.3 }}
            className="mobile-nav"
          >
            <button className="close-menu" onClick={toggleDrawer}>
              &times;
            </button>
            <Link to="/home" onClick={toggleDrawer}>
              Home
            </Link>
            <Link to="/aboutus" onClick={toggleDrawer}>
              About Us
            </Link>
            <Link to="/sampledrawings" onClick={toggleDrawer}>
              Sample Drawings
            </Link>
            <Link to="/contactus" onClick={toggleDrawer}>
              Contact Us
            </Link>
          </motion.div>

          {/* Overlay for drawer */}
          <div className="fixed inset-0 bg-black" onClick={toggleDrawer}></div>
        </>
      )}
    </header>
  );
};

export default Header;
